import styled from "@emotion/styled";
import { useState } from "react";
import { ContactApi } from "../../../api/Contacts";
import { IContact } from "../../../generated/Api";
import IconBerserkerMail from "../../Icon";

const Container = styled.div`
  width: 100%;
  margin: 10px 0px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 16px;
`;

const Key = styled.div`
  font-weight: 700;
`;

const Value = styled.div``;

const IconDiv = styled.div`
  margin: 0px 10px;
  cursor: pointer;
`;

interface Props {
  contact: IContact;
}

function Field(
  key: string,
  valueFromParams: string,
  updateField: (value: string) => Promise<boolean>
) {
  const [value, setValue] = useState(valueFromParams);
  const [isEdit, setIsEdit] = useState(false);

  return (
    <Row>
      <Key>{key}: </Key>
      {isEdit ? (
        <input value={value} onChange={(evt) => setValue(evt.target.value)} />
      ) : (
        <Value>{value}</Value>
      )}
      {isEdit ? (
        <IconDiv
          onClick={async () => {
            const r = await updateField(value);
            if (r) setIsEdit(!isEdit);
          }}
        >
          <IconBerserkerMail name="save" />
        </IconDiv>
      ) : (
        <IconDiv onClick={() => setIsEdit(!isEdit)}>
          <IconBerserkerMail name="edit" />
        </IconDiv>
      )}
    </Row>
  );
}

export default function CustomFields(props: Props) {
  const { customFields, _id, email } = props.contact;

  async function updateField(customFields: any) {
    const isSuccess = await ContactApi.update(
      { customFields, email },
      _id as string
    );

    return !!isSuccess;
  }

  return (
    <Container>
      {customFields &&
        Object.keys(customFields).map((keyFromField) => {
          return Field(
            keyFromField,
            customFields[keyFromField],
            async (newValue: string) => {
              const customFieldsAux = { ...customFields };
              customFieldsAux[keyFromField] = newValue;

              const r = await updateField(customFieldsAux);

              return r;
            }
          );
        })}
    </Container>
  );
}
